import { visionOptions } from "../constants/visionOptions"
import { getPlanStudentFirstName } from "../lib/plan"

const GoalBlock = ({ data, plan }) => {
  return (
    <div className="mb-8">
      <h1 className="mb-4 text-xl font-bold text-vision">
        {getPlanStudentFirstName(plan) !== "" ? getPlanStudentFirstName(plan) + "'s" : "Student's"}{" "}
        Life Areas and Goals
      </h1>
      <div className="grid grid-cols-1 gap-4">
        {data.visions.flatMap(item => {
          const option = visionOptions.find(opt => opt.value === item)
          if (!option) return []
          const optionDetail = data[`${option.value}_vision`] ?? ""
          return (
            <div key={item} className="flex flex-col w-full md:grid md:grid-cols-4 gap-2 md:items-start">
              <span
                key={item}
                className="grow-0 rounded-full border border-vision px-1 py-1 text-center capitalize text-vision text-sm"
              >
                {item !== "other" ? option.label : data.other_title}
              </span>
              {optionDetail && (<div className="ml-2 col-span-2 md:col-span-3">{optionDetail}</div>)}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default GoalBlock
